




















import Button from '@/components/ext/Button.vue';
export default {
  props: {
    /**
     * принимает
     * {
     *             /// success/error
     *             type: 'error',
     *             /// опционально, если не указанны выведет дефолт месаги
     *             text: {
     *               ...(firstErrorMsg &&
     *                 firstErrorMsg.msg && { description: firstErrorMsg.msg }),
     *             },
     *           }
     * **/
    message: {
      type: Object,
      // default: (val: any) => ({
      //   type: val?.type || 'success',
      // }),
    },
    closeModal: {},
  },
  components: {
    Button,
  },
  computed: {
    msg() {
      const _message = this.message?.type ? this.message : { type: 'success' };
      const defaultTextMsg: any = {
        success: {
          title: 'Заявка принята и будет обработана в ближайшее время.',
          warning:
            'Внимание! Настоящая заявка не является фактом зачисления на обучение.',
          description:
            'На вашу электронную почту будет направлено письмо о подтверждении заявки. ' +
            'Уточнить статус заявки вы сможете в своем личном кабинете.',
        },
        error: {
          title: 'Ошибка обработки заявки.',
          warning: null,
          description: 'Произошла ошибка или сервис временно не доступен.',
        },
      };
      return {
        type: _message.type,
        text: {
          title: _message.text?.title || defaultTextMsg[_message.type].title,
          warning:
            _message.text?.warning || defaultTextMsg[_message.type].warning,
          description:
            _message.text?.description ||
            defaultTextMsg[_message.type].description,
        },
      };
    },
  },
};



// WEBPACK FOOTER //
// ./node_modules/vue-loader/lib/selector.js?type=script&index=0!./src/components/ordersProcessForms/parts/finishMessage/FinishMessage.vue